<!--
  EmptyState — estado vacío de Otera. Reemplaza a EmptyStateLegacy.
  El headline va en <p> (UX-DR11): el contenedor padre posee el heading
  semántico. Usa las clases .empty* de otera-mockups.css.
-->

<script setup>
import Icon from './Icon.vue';

defineOptions({ name: 'DsEmptyState' });

defineProps({
  // `headline` se mantiene como alias de `title` por compatibilidad con
  // los call-sites de EmptyStateLegacy.
  title: { type: String, default: null },
  headline: { type: String, default: null },
  body: { type: String, default: null },
  icon: { type: String, default: null }
});
</script>

<template>
  <div class="empty">
    <div class="empty__icon">
      <slot name="icon">
        <Icon
          v-if="icon"
          :name="icon"
          :size="20"
        />
      </slot>
    </div>
    <p class="empty__title">
      {{ title || headline }}
    </p>
    <p
      v-if="body"
      class="empty__sub"
    >
      {{ body }}
    </p>
    <div
      v-if="$slots.actions"
      class="empty__actions"
    >
      <slot name="actions" />
    </div>
  </div>
</template>
